import React from "react";

import './HomePage.css'
import TopNav from "../components/TopNav";
import Dashboard from "../components/Dashboard";

const HomePage = (props) => {

    return(
        <React.Fragment>
            <TopNav page={props.page} darkMode={props.darkmode}  admin={props.admin}/>
            <Dashboard iid={props.iid} toggle={props.toggleTheme} darkMode={props.darkmode} onRefetch={props.refetchUserData} admin={props.admin} onLogout={props.onLogout}/>
        </React.Fragment>)
}
export default HomePage;